import { html } from '@polymer/polymer/polymer-element.js';
import '@polymer/polymer/lib/elements/dom-repeat.js';
import { GlobalBase } from './global-base.js';

export class DbqUnitComList extends GlobalBase {
  static get is() {
    return 'dbq-unit-com-list';
  }

  static get template() {
    return html`
      <dbq-dropdown id="customComment" hidden$="[[!feedback]]" title="Custom Comment">
        <a class="dropTitle" >
          <svg class="icon icon-sm-gap-end icon-size-match" aria-hidden="true">
            <use href="/static/svg/custom-icons.svg#custom-comment" />
          </svg>
          <span class="uk-visible@s uk-hidden@m"> Comment</span>
          <span class="uk-visible@m"> Custom Comment</span>
          <svg class="icon icon-size-match" aria-hidden="true">
            <use href="/static/svg/custom-icons.svg#caret-down" />
          </svg>
        </a>
        <div class="dropMenu">
          <template id="commentList"
          is="dom-repeat"
          sort="compareNumbers"
          items='{{comments}}'
          as="comment"
          mutable-data>
            <a on-click="addElement" custom-text$="[[comment.comment]]" custom-color$="[[comment.color]]" anno-type="custom" class$="dropItem [[nameFor(comment.color)]]" >
            [[truncate(comment.comment)]]
            </a>
          </template>
        </div>
      </dbq-dropdown>
    `;
  }

  static get properties() {
    return {
      comments: {
        type: Array,
        value: function(){
          return [];
        }
      },
      category: {
        type: String,
        value:'unit'
      },
      avalibleColors: {
        type: Array,
        value: function(){
          return [
            {name:'red', code: 'rgb(218, 19, 24)'},
            {name:'orange', code: 'rgb(240, 143, 44)'},
            {name:'yellow', code:  'rgb(255, 255, 51)'},
            {name:'green', code: 'rgb(118, 189, 72)'},
            {name:'blue', code: 'rgb(91, 169, 247)'},
            {name:'purple', code: 'rgb(176, 114, 224)'},
            {name:'gray', code: 'rgb(153, 153, 153)'},
            {name:'black', code: 'rgb(0, 0, 0)'},
            {name:'white', code: 'rgb(255, 255, 255)'}
          ]
        }
      },
    }
  }

  ready() {
    super.ready();
    this.getComments();
  }

  truncate(comment){
    return comment.substring(0,60);
  }

  getComments(){
    fetch('/instructor/api/instructor-comments/', {
      method: 'GET',
      headers: {
        'X-CSRFToken': this.token
      },
      credentials: 'same-origin'
    }).then(
      (response) => {
        var returnVal;
        if (response.status !== 200) {
          returnVal = response;

        } else {
          returnVal = response.json();
        }
        return returnVal;
      },
      (error) => {
        return error.message;
      }
    ).then((data) => {
      let newComments = data.filter(this.matchesCategory.bind(this))
      console.log("DbqUnitComList -> getComments -> newComments", newComments)
      this.set('comments', newComments);
      return data;
    });
  }

  nameFor(color){
    let returnVal = 'blue'
    this.avalibleColors.forEach((el) => {
      if(el.code === color){
        returnVal = el.name
      }
    });
    return returnVal;
  }

  compareNumbers(a, b) {
    // console.log("DbqCustomCommentGrid -> compareNumbers -> a, b", a, b)
    return a.display_order - b.display_order;
  }

  addElement(event){
    this.parentNode.closest('sw-annotation-nav').addElement(event);
    this.querySelector('dbq-dropdown').close();
  }

  matchesCategory(item){
    return this.category === item.category || item.category === null
  }

  _attachDom(dom) {
    this.appendChild(dom);
  }
}
customElements.define(DbqUnitComList.is, DbqUnitComList);
